
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire46ec"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire46ec"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRequire("f2DfV");
parcelRequire("5SEZ9");
const $484901257dc4a065$var$navigation = document.querySelector(".nav");
const $484901257dc4a065$var$page = document.querySelector(".page");
$484901257dc4a065$var$navigation?.addEventListener("click", $484901257dc4a065$var$onBurgerBtnClick);
function $484901257dc4a065$var$onBurgerBtnClick(e) {
    if (!e.target.parentNode.matches(".burger") && !e.target.matches(".burger")) return;
    this?.classList.remove("closed");
    $484901257dc4a065$var$page?.classList.add("open");
    if (this?.matches(".opened")) {
        this?.classList.add("closed");
        $484901257dc4a065$var$page?.classList.remove("open");
        setTimeout(()=>{
            this?.classList.remove("opened");
        }, 100);
    }
    this?.classList.add("opened");
}


// const filterList = document.querySelector(".filter");
// const filterButtons = filterList.querySelectorAll(".filter-btn");
// const services = document.querySelectorAll(".service");
// let servicesIndex = 0;
// services.forEach((services) => {
//   services.style.viewTransitionName = `conf-${++servicesIndex}`;
// });
// filterButtons.forEach((button) => {
//   button.addEventListener("click", (e) => {
//     let confCategory = e.target.getAttribute("data-filter");
//     if (!document.startViewTransition) {
//       updateActiveButton(e.target);
//       filterEvents(confCategory);
//     }
//     document.startViewTransition(() => {
//       updateActiveButton(e.target);
//       filterEvents(confCategory);
//     });
//   });
// });
// function updateActiveButton(newButton) {
//   filterList.querySelector(".active").classList.remove("active");
//   newButton.classList.add("active");
// }
// function filterEvents(filter) {
//   services.forEach((services) => {
//     // get each servicess category
//     let eventCategory = services.getAttribute("data-category");
//     // check if that category matches with the filter
//     if (filter === eventCategory) {
//       services.removeAttribute("hidden");
//     } else {
//       services.setAttribute("hidden", "");
//     }
//   });
// }


const $87f5239ba2f4232b$var$tabs = document.querySelector(".tabs");
let $87f5239ba2f4232b$var$tabsButtons = null;
let $87f5239ba2f4232b$var$tabsPanels = null;
let $87f5239ba2f4232b$var$tabIdFromUrl = window.location.hash.substring(1);
if ($87f5239ba2f4232b$var$tabs) {
    $87f5239ba2f4232b$var$tabsButtons = Array.from($87f5239ba2f4232b$var$tabs.querySelectorAll('[role="tab"]'));
    $87f5239ba2f4232b$var$tabsPanels = Array.from($87f5239ba2f4232b$var$tabs.querySelectorAll('[role="tabpanel"]'));
    if ($87f5239ba2f4232b$var$tabIdFromUrl) $87f5239ba2f4232b$var$tabsButtons.forEach((button)=>{
        if (button.id === $87f5239ba2f4232b$var$tabIdFromUrl) $87f5239ba2f4232b$var$handleClick(button, $87f5239ba2f4232b$var$tabIdFromUrl);
    });
}
if ($87f5239ba2f4232b$var$tabsButtons) $87f5239ba2f4232b$var$tabsButtons.forEach((button)=>button.addEventListener("click", $87f5239ba2f4232b$var$handleClick));
function $87f5239ba2f4232b$var$handleClick(ev, tabIdFromUrl) {
    $87f5239ba2f4232b$var$tabsPanels.forEach((el)=>{
        el.hidden = true;
    });
    $87f5239ba2f4232b$var$tabsButtons.forEach((button)=>{
        button.setAttribute("aria-selected", "false");
    });
    if (tabIdFromUrl) {
        console.log(tabIdFromUrl);
        console.log(ev);
        ev.setAttribute("aria-selected", "true");
        const tabPanel = $87f5239ba2f4232b$var$tabsPanels.find((elem)=>{
            if (tabIdFromUrl === elem.getAttribute("aria-labelledby")) return true;
        });
        tabPanel.hidden = false;
        window.location.hash = "";
    } else {
        ev.currentTarget.setAttribute("aria-selected", "true");
        const { id: id } = ev.currentTarget;
        const tabPanel = $87f5239ba2f4232b$var$tabsPanels.find((elem)=>{
            if (id === elem.getAttribute("aria-labelledby")) return true;
        });
        tabPanel.hidden = false;
    }
}






//# sourceMappingURL=about.881d3818.js.map
